import React from 'react'
import { Switch as RouterSwitch, Route } from 'react-router-dom'
import { NotFoundPage } from '../pages/_404'

type Props = {
  children?: React.ReactNode
}

export const Switch = ({ children }: Props) => (
  <RouterSwitch>
    {children}
    <Route component={NotFoundPage} />
  </RouterSwitch>
)
